(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHeader = () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    const onScroll = () => {
      headerWrapper.classList.toggle('hh-header--scrolled', window.scrollY > 24);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const initReveal = () => {
    const nodes = document.querySelectorAll('.hh-reveal');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach((el) => observer.observe(el));
  };

  const initHero = () => {
    const heroes = document.querySelectorAll('[data-hh-hero], .hh-hero');
    if (!heroes.length) return;

    heroes.forEach((hero) => {
      const animateIn = () => {
        hero.classList.add('hh-hero--ready');
        hero.querySelectorAll('[data-hh-animate]').forEach((el) => el.classList.add('is-in'));
      };

      if (reduceMotion) {
        animateIn();
        return;
      }

      requestAnimationFrame(animateIn);

      const allowMobileVideo = hero.getAttribute('data-hh-video-mobile') === 'true';
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const video =
        hero.querySelector('.hh-hero__video-wrap video') ||
        hero.querySelector('video.hh-hero__video') ||
        hero.querySelector('.hh-hero__video-wrap video');

      /* YouTube is never embedded — still image only (avoids play/pause UI) */
      if (hero.querySelector('[data-hh-youtube]')) {
        return;
      }

      if (!video) {
        if (hero.querySelector('.hh-hero__video-wrap--embed')) {
          hero.classList.add('hh-hero--playing');
          hero.querySelectorAll('.hh-hero__embed').forEach((frame) => {
            frame.setAttribute('tabindex', '-1');
            frame.setAttribute('inert', '');
            frame.style.pointerEvents = 'none';
          });
        }
        return;
      }

      if (isMobile && !allowMobileVideo) {
        video.pause?.();
        return;
      }

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      const markPlaying = () => hero.classList.add('hh-hero--playing');

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(markPlaying).catch(() => {
            hero.classList.remove('hh-hero--playing');
          });
        } else {
          markPlaying();
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      video.addEventListener('playing', markPlaying);
    });
  };

  const boot = () => {
    initHeader();
    initReveal();
    initHero();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    initReveal();
    initHero();
  });
})();
